import type { ClientType } from './oauthAppsConstants';

export interface OAuthApp {
  id: string;
  clientId: string;
  applicationName: string;
  redirectUris: string[];
  scopes: string[];
  clientType: ClientType;
  hasClientSecret: boolean;
  clientSecretLast4: string | null;
  clientSecret?: string | null;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface OAuthAppFormState {
  applicationName: string;
  redirectUris: string[];
  scopes: string[];
  clientType: ClientType;
}

export interface OAuthSecretReveal {
  clientId: string;
  clientSecret: string;
  applicationName: string;
  redirectUris: string[];
  scopes: string[];
}

export function emptyOAuthAppForm(): OAuthAppFormState {
  return {
    applicationName: '',
    redirectUris: [''],
    scopes: ['openid'],
    clientType: 'confidential',
  };
}

export function formFromApp(app: OAuthApp): OAuthAppFormState {
  return {
    applicationName: app.applicationName,
    redirectUris: app.redirectUris.length ? [...app.redirectUris] : [''],
    scopes: app.scopes.length ? [...app.scopes] : ['openid'],
    clientType: app.clientType,
  };
}
